
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/ProjectFilterCreateOrganization/ProjectFilterCreateOrganization.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./ProjectFilterCreateOrganization.html');
        
        var script = require('./ProjectFilterCreateOrganization.ts').default;
        module.exports = require('./ProjectFilterCreateOrganization.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    